/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Jade_Eel_FadeInputs */

const en_cool_jade_eel_fade = /** @type {(inputs: Cool_Jade_Eel_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export the current users as CSV file.`)
};

const de_cool_jade_eel_fade = /** @type {(inputs: Cool_Jade_Eel_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportiere die aktuellen Benutzer als CSV-Datei.`)
};

/**
* | output |
* | --- |
* | "Export the current users as CSV file." |
*
* @param {Cool_Jade_Eel_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_jade_eel_fade = /** @type {((inputs?: Cool_Jade_Eel_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Jade_Eel_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_jade_eel_fade(inputs)
	return de_cool_jade_eel_fade(inputs)
});